@if (localConfig) {
  <mwe-basic-card
    [cardTitle]="localConfig.titleKey"
    [hasBackground]="true"
    [headingNodeType]="headingNodeType"
    iconClass="fas fa-gift-card"
  >
    <div class="row">
      <div class="col-12">
        <div class="has-text-button">
          <div class="pb-2 pt-2">
            <mwe-form
              #codeForm
              (formIsInvalid)="onFormChange($event)"
              (formIsValid)="onFormChange($event)"
              [formModel]="voucherFormModel"
              [suppressValidityCheckOnSubmit]="true"
            />
            @if (showWLFields) {
              <mwe-wl-voucher-form
                (checkPressed)="wlFormCheckPressed($event)"
                (formValid)="wlFormValidityChanged($event)"
                [aktionsArt]="aktionsArt"
                [config]="localConfig"
                [loading]="loading"
                [prozesstyp]="prozesstyp"
              />
            }
          </div>
        </div>
      </div>
    </div>
    @if (localConfig.infoText) {
      <div class="row pb-2">
        <mwe-infobox [messageKey]="localConfig.infoText" />
      </div>
    }
  </mwe-basic-card>
}

@if (!!codeCheck) {
  <div class="mt-5">
    @if (codeCheck === 'invalid') {
      <mwe-alert
        [messageKey]="showWLFields ? localConfig.invalidCodeWLMsgKey : localConfig.invalidCodeMsgKey"
        titleKey="voucher.invalidTitle"
        type="danger"
      />
    }
    @if (codeCheck === 'error') {
      <mwe-alert [messageKey]="errorMessageKey" [titleKey]="errorTitleKey || 'voucher.invalidTitle'" [type]="errorAlertStyle" />
    }
    @if (codeCheck === 'warning') {
      <mwe-alert
        (onLinkClick)="handleWarningLinkClicked()"
        [infoText]="isTariffNotValidError ? tariffNotValidInfoText : null"
        [link]="isTariffNotValidError ? 'voucher.validity.tariffNotValid.link' : ''"
        [messageKey]="errorMessageKey"
        type="warning"
      />
    }
    @if (codeCheck === 'valid') {
      <mwe-basic-card cardTitle="voucher.validity.success.title" headingNodeType="h4" iconClass="fas fa-gift-card">
        <mwe-green-check-list [labels]="uiSuccessInfos" />
      </mwe-basic-card>
    }
  </div>
}

@if (hasFaq) {
  <div class="mt-5" role="complementary" data-test="voucher-form-faq">
    <h2 translate="voucher.faq.title"></h2>
    <mwe-link-list-group [items]="localConfig.faq" />
  </div>
}
